import { render } from "./Pill.vue?vue&type=template&id=39e5b2b9&scoped=true"
import script from "./Pill.vue?vue&type=script&lang=js"
export * from "./Pill.vue?vue&type=script&lang=js"

import "./Pill.vue?vue&type=style&index=0&id=39e5b2b9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e5b2b9"]])

export default __exports__